import { useVuelidate } from '@vuelidate/core'
import { required, maxLength } from '@vuelidate/validators'

import { Modal } from 'bootstrap';

export default {

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      distributor: null,
      criterias: {
        selectedDistributorRef: '',
        selectedDistributorName: ''
      },
      responseErr: null,
      isProcessing: false,
      validationError: false
    }
  },

  created () {
    // this.distributor = this.$route.params.distributor
    this.getDetail(this.$store.state.distributors.distributor.reference)
  },

  methods: {
    async getDetail (distributorReference) {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('distributors/detail', {
        reference: distributorReference
      }).then(
        response => {
          this.distributor = response
          this.criterias.selectedDistributorRef = this.distributor.reference
          this.criterias.selectedDistributorName = this.distributor.name
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },
    editDistributer () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.edit()
      }
    },

    async edit () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      await this.$store.dispatch('distributors/reset')
      await this.$store.dispatch('distributors/update', {
        // issuerId: this.getIssuerId(this.distributor.reference),
        reference: this.distributor.reference,
        name: this.criterias.selectedDistributorName
      }).then(
        () => {
          successMsg = this.$i18n.t('label.distributor.distributorUpdatedSuccess', [this.distributor.reference] )
          this.showSuccess(successMsg)
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },
    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    leavePage () {
      this.$router.push({ name: 'distributor-list' })
    }
  },

  validations() {
    return {
      criterias: {
        selectedDistributorRef: { required },
        selectedDistributorName: { required, maxLength: maxLength(100) }
      }
    }
  }
}
